import { Navigate, Outlet } from 'react-router-dom'
import HeadHelmet from 'components/route/HeadHelmet'
import useRouteData from 'hooks/useRouteData'
import { SITE_ADMIN_COURSE_EDITOR_ROOT, SITE_USER_ROOT } from 'config'
import { useAuth } from 'react-oidc-context'
import useUserRole from 'hooks/useUserRole'
import OverlayLoader from 'components/ui/OverlayLoader'
import { ClientRoute } from 'routes/client'

export default function AdminGuard(): JSX.Element {
  const { titleId = '' } = useRouteData()
  const oicdAuth = useAuth()
  const { isGpsEditor, isAdminCourseEditor, isLoading, isAdmin } = useUserRole()

  if (isLoading || !oicdAuth.isAuthenticated) {
    return <OverlayLoader visible={true} />
  }

  if (oicdAuth.isAuthenticated && isGpsEditor) {
    return <Navigate to={SITE_USER_ROOT} />
  }

  if (oicdAuth.isAuthenticated && isAdminCourseEditor) {
    return <Navigate to={SITE_ADMIN_COURSE_EDITOR_ROOT} replace />
  }

  if (!isAdmin) {
    return <Navigate to={ClientRoute.LOGIN} />
  }

  return (
    <>
      <HeadHelmet titleId={titleId} />
      <Outlet />
    </>
  )
}
